/* Pup & Pur theme — all interactivity, no dependencies. Loaded with `defer`. */
(() => {
  'use strict';
  const PP = window.PP || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const on = (type, sel, fn) => document.addEventListener(type, (e) => {
    const t = e.target.closest && e.target.closest(sel);
    if (t) fn(e, t);
  });
  const money = (c) => { const r = Math.round(c); return '₹' + (r / 100).toLocaleString('en-IN', { minimumFractionDigits: r % 100 ? 2 : 0, maximumFractionDigits: 2 }); };
  const routes = PP.routes || {};
  const root = (routes.root || '/').replace(/\/?$/, '/');

  /* ---------------- toast ---------------- */
  const toastEl = $('[data-toast]');
  let toastTimer;
  // toast(title, withLink, sub): "Added to bag" + product name + View bag stays 5 s; plain notes 3 s. Hover/focus pauses it.
  function hideToast() {
    if (!toastEl || toastEl.hidden) return;
    toastEl.setAttribute('data-out', '');
    setTimeout(() => { if (toastEl.hasAttribute('data-out')) toastEl.hidden = true; }, 220);
  }
  function armToast(ms) { clearTimeout(toastTimer); toastTimer = setTimeout(hideToast, ms); }
  function toast(msg, withLink = true, sub = '') {
    if (!toastEl) return;
    $('[data-toast-text]', toastEl).textContent = msg;
    const subEl = $('[data-toast-sub]', toastEl);
    if (subEl) { subEl.textContent = sub; subEl.hidden = !sub; }
    const link = $('.toast-cta', toastEl);
    if (link) link.hidden = !withLink;
    toastEl.hidden = false;
    toastEl.removeAttribute('data-out');
    toastEl.dataset.ms = withLink ? 5000 : 3000;
    armToast(Number(toastEl.dataset.ms));
  }
  if (toastEl) {
    toastEl.addEventListener('mouseenter', () => clearTimeout(toastTimer));
    toastEl.addEventListener('mouseleave', () => armToast(2000));
    toastEl.addEventListener('focusin', () => clearTimeout(toastTimer));
    toastEl.addEventListener('focusout', () => armToast(2000));
    on('click', '[data-toast-close]', () => { clearTimeout(toastTimer); hideToast(); });
  }
  PP.toast = toast;

  /* ---------------- cart api ---------------- */
  async function api(url, body) {
    const res = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
    $$('[data-cart-link]').forEach((el) => el.setAttribute('aria-label', 'Bag, ' + n + ' items'));
  }
  async function refreshCart() {
    const cart = await api(root + 'cart.js');
    setCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('pp:cart', { detail: cart }));
    return cart;
  }
  async function addItems(items, label, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      await api(root + 'cart/add.js', { items });
      await refreshCart();
      if (label) { const name = label.replace(/ added$/, ''); toast('Added to bag', true, name === 'Added to bag' ? '' : name); }
      return true;
    } catch (err) {
      toast(err.message, false);
      return false;
    } finally {
      if (btn) btn.removeAttribute('aria-busy');
    }
  }
  PP.addItems = addItems;
  PP.refreshCart = refreshCart;

  // Quick add (+) on cards, kit buttons, finder "Add to bag"
  on('click', '[data-add]', (e, btn) => {
    e.preventDefault();
    const id = Number(btn.dataset.add);
    if (!id) return;
    const qty = Number(btn.dataset.qty || 1);
    addItems([{ id, quantity: qty }], (btn.dataset.name || 'Item') + ' added', btn).then((ok) => {
      if (ok && btn.dataset.addedLabel) btn.textContent = btn.dataset.addedLabel;
      if (ok && btn.dataset.redirect) location.href = btn.dataset.redirect;
    });
  });

  /* ---------------- drawer ---------------- */
  const drawer = $('#pp-drawer');
  const scrim = drawer && drawer.previousElementSibling && drawer.previousElementSibling.matches('.scrim') ? drawer.previousElementSibling : null;
  let lastFocus;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false; if (scrim) scrim.hidden = false;
    document.documentElement.classList.add('pp-lock');
    $$('[data-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const f = $('button, a, input', drawer); if (f) f.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true; if (scrim) scrim.hidden = true;
    document.documentElement.classList.remove('pp-lock');
    $$('[data-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }
  on('click', '[data-drawer-open]', openDrawer);
  on('click', '[data-drawer-close]', closeDrawer);

  /* ---------------- generic sheets (filters) ---------------- */
  function openSheet(id) {
    const sheet = document.getElementById(id); if (!sheet) return;
    sheet.hidden = false; const s = sheet.previousElementSibling; if (s && s.matches('.scrim')) s.hidden = false;
    document.documentElement.classList.add('pp-lock');
    const f = $('button', sheet); if (f) f.focus();
  }
  function closeSheets() {
    $$('.sheet').forEach((sheet) => {
      if (sheet.hidden) return;
      sheet.hidden = true; const s = sheet.previousElementSibling; if (s && s.matches('.scrim')) s.hidden = true;
    });
    document.documentElement.classList.remove('pp-lock');
  }
  on('click', '[data-sheet-open]', (e, b) => openSheet(b.dataset.sheetOpen));
  on('click', '[data-sheet-close]', closeSheets);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeSheets(); } });

  /* ---------------- copy code / link ---------------- */
  on('click', '[data-copy]', async (e, btn) => {
    e.preventDefault();
    try { await navigator.clipboard.writeText(btn.dataset.copy); } catch (_) { /* ignore */ }
    const label = $('[data-copy-label]', btn) || btn;
    label.textContent = 'Copied';
  });
  on('click', '[data-share]', async (e, btn) => {
    e.preventDefault();
    const data = { title: document.title, url: btn.dataset.share || location.href };
    if (navigator.share) { try { await navigator.share(data); return; } catch (_) { return; } }
    try { await navigator.clipboard.writeText(data.url); toast('Link copied', false); } catch (_) { /* ignore */ }
  });

  /* ---------------- chips that act as a single-choice input ---------------- */
  on('click', '[data-chip-group] [data-chip]', (e, chip) => {
    const group = chip.closest('[data-chip-group]');
    $$('[data-chip]', group).forEach((c) => { c.classList.toggle('chip-on', c === chip); c.setAttribute('aria-pressed', c === chip); });
    const input = $('input[type=hidden]', group);
    if (input) input.value = chip.dataset.chip;
  });

  /* ---------------- segmented pet filter on rails (home "Most loved") ---------------- */
  const segApply = (btn, keepScroll) => {
    const seg = btn.closest('[data-seg]');
    $$('[data-val]', seg).forEach((b) => { b.classList.toggle('on', b === btn); b.setAttribute('aria-pressed', b === btn); });
    const target = document.getElementById(seg.dataset.seg);
    if (!target) return;
    const v = btn.dataset.val;
    $$('[data-card]', target).forEach((c) => {
      const pets = (c.dataset.pets || '').split(' ');
      c.toggleAttribute('data-out', v !== 'all' && pets.length > 0 && pets[0] !== '' && !pets.includes(v));
    });
    if (!keepScroll) target.scrollLeft = 0;
  };
  on('click', '[data-seg] [data-val]', (e, btn) => segApply(btn));
  $$('[data-seg]').forEach((seg) => { const b = $('[data-val].on', seg) || $('[data-val]', seg); if (b) segApply(b, true); });

  /* ---------------- header height → --hdr-h (sticky filter bar sits right under the header) ---------------- */
  const hdr = $('[data-header]');
  if (hdr) {
    const setH = () => document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(hdr);
  }

  /* ---------------- wash finder (quiz) ---------------- */
  $$('[data-quiz]').forEach((quiz) => {
    let data;
    try { data = JSON.parse($('[data-quiz-data]', quiz).textContent); } catch (_) { return; }
    const state = { pet: quiz.dataset.pet || 'dog', concern: quiz.dataset.concern || 'itchy' };
    const pick = () => {
      const s = state;
      let role = 'fourinone';
      if (s.concern === 'itchy') role = 'oatmeal';
      else if (s.concern === 'ticks') role = 'tickflea';
      else if (s.concern === 'smell') role = 'odour';
      else if (s.concern === 'tangles') role = s.pet === 'dog' ? 'conditioner' : 'fourinone';
      else if (s.concern === 'eyes') role = 'notear';
      else if (s.concern === 'regular') role = 'fourinone';
      if (s.pet === 'baby' && (s.concern === 'smell' || s.concern === 'tangles')) role = 'notear';
      let p = data[role] || data.fourinone || Object.values(data)[0];
      if (!p) return;
      let why = p.why;
      if (role === 'fourinone' && s.concern === 'tangles' && data.tanglesCatNote) why = data.tanglesCatNote;
      const set = (k, v) => { const el = $('[data-m="' + k + '"]', quiz); if (el) el.textContent = v; };
      set('name', p.name); set('why', why); set('price', p.price); set('mrp', p.mrp || '');
      const shown = data[role] ? role : Object.keys(data).find((k) => data[k] === p);
      $$('[data-role]', quiz).forEach((im) => { const onNow = im.dataset.role === shown; im.classList.toggle('q-on', onNow); im.alt = onNow ? p.name : ''; });
      const add = $('[data-m="add"]', quiz); if (add) { add.dataset.add = p.variant; add.dataset.name = p.name; add.disabled = !p.variant; }
      const link = $('[data-m="url"]', quiz); if (link) link.href = p.url;
    };
    const press = (k, b) => {
      state[k] = b.dataset.v;
      $$('[data-q="' + k + '"]', quiz).forEach((x) => { x.classList.toggle('chip-on', x === b); x.setAttribute('aria-pressed', x === b); });
    };
    // show only the concerns that apply to the chosen pet; fall back to the first one shown
    const fitConcerns = () => {
      const chips = $$('[data-q="concern"]', quiz);
      chips.forEach((c) => { c.hidden = !(c.dataset.for || '').split(' ').includes(state.pet); });
      const curChip = chips.find((c) => c.dataset.v === state.concern);
      if (!curChip || curChip.hidden) { const first = chips.find((c) => !c.hidden); if (first) press('concern', first); }
    };
    on('click', '[data-quiz] [data-q]', (e, b) => {
      if (!quiz.contains(b)) return;
      press(b.dataset.q, b);
      if (b.dataset.q === 'pet') fitConcerns();
      pick();
    });
    fitConcerns();
    pick();
  });

  /* ---------------- product page ---------------- */
  $$('[data-product]').forEach((pr) => {
    const form = $('[data-product-form]', pr);
    // gallery: every photo sits in one swipeable track, so switching is a scroll, never a new download
    const track = $('[data-gallery-track]', pr);
    if (track) {
      const thumbs = $$('[data-thumb]', pr);
      const counter = $('[data-gallery-n]', pr);
      let cur = 0;
      const mark = (i) => {
        if (i === cur) return; cur = i;
        thumbs.forEach((x, k) => { x.classList.toggle('thumb-on', k === i); x.setAttribute('aria-current', k === i); });
        $$('.gallery-slide', track).forEach((sl, k) => { if (k === i) sl.removeAttribute('aria-hidden'); else sl.setAttribute('aria-hidden', 'true'); });
        if (counter) counter.textContent = i + 1;
      };
      on('click', '[data-thumb]', (e, t) => {
        if (!pr.contains(t)) return;
        const i = Number(t.dataset.n) - 1;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'instant' });
        mark(i);
      });
      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      }, { passive: true });
      // once the page has loaded, fetch the remaining photos in the background
      const warm = () => $$('img[loading="lazy"]', track).forEach((im) => { im.loading = 'eager'; });
      if (document.readyState === 'complete') setTimeout(warm, 200); else window.addEventListener('load', () => setTimeout(warm, 200), { once: true });
    }
    if (!form) return;
    const state = { qty: 1 };
    const priceEl = $('[data-p-price]', pr), mrpEl = $('[data-p-mrp]', pr), offEl = $('[data-p-off]', pr);
    const sticky = $('[data-sticky-atc]');
    const current = () => $('[data-pack].pack-on', form) || $('[data-pack]', form);
    // each size has its own photo on slide 1: switch to it and jump the gallery back to the start
    function showVariantImage(id) {
      const imgs = $$('[data-vimg]', pr);
      if (!imgs.some((im) => im.dataset.vimg === String(id))) return;
      imgs.forEach((im) => im.classList.toggle('v-on', im.dataset.vimg === String(id)));
      const tr = $('[data-gallery-track]', pr); if (tr) tr.scrollTo({ left: 0, behavior: 'instant' });
      const t1 = $('[data-thumb][data-n="1"]', pr); if (t1) t1.click();
      const big = $('.gallery-slide img.v-on', pr), mini = sticky && $('.mini-thumb img', sticky);
      if (big && mini) { mini.srcset = ''; mini.src = big.currentSrc || big.src; }
    }
    // "Pack of 2" style options follow the chosen size (2 × 200 ml when 200 ml is picked)
    function followSize(vp) {
      $$('[data-pack][data-follow]', form).forEach((k) => {
        const u = Number(k.dataset.units || 1), price = Number(vp.dataset.price) * u, mrp = Number(vp.dataset.mrp) * u;
        k.dataset.variant = vp.dataset.variant; k.dataset.price = price; k.dataset.mrp = mrp; k.dataset.available = vp.dataset.available;
        k.disabled = vp.dataset.available === 'false';
        const pe = $('[data-pk-price]', k), me = $('[data-pk-mrp]', k);
        if (pe) pe.textContent = money(price);
        if (me) { me.textContent = money(mrp); me.hidden = !(mrp > price); }
      });
    }
    function render() {
      const p = current(); if (!p) return;
      const price = Number(p.dataset.price) * state.qty, mrp = Number(p.dataset.mrp) * state.qty;
      if (priceEl) priceEl.textContent = money(price);
      const promo = $('[data-promo-pct]', pr), pp = promo && $('[data-promo-price]', promo);
      if (pp) pp.textContent = money(Math.floor(price * (100 - Number(promo.dataset.promoPct)) / 100));
      if (mrpEl) { mrpEl.textContent = mrp > price ? money(mrp) : ''; }
      if (offEl) { const off = mrp > price ? Math.round((1 - price / mrp) * 100) : 0; offEl.textContent = off + '% off'; offEl.hidden = off <= 0; }
      $$('[data-qty-val]', pr).forEach((el) => { el.textContent = state.qty; });
      const avail = p.dataset.available !== 'false';
      $$('[data-atc], [data-buy]', pr).forEach((b) => { b.disabled = !avail; });
      if (sticky) {
        $('[data-sticky-price]', sticky).textContent = money(price);
        const sm = $('[data-sticky-mrp]', sticky); if (sm) sm.textContent = mrp > price ? money(mrp) : '';
      }
      const id = $('input[name=id]', form); if (id) id.value = p.dataset.variant;
    }
    on('click', '[data-pack]', (e, p) => {
      if (!form.contains(p)) return;
      $$('[data-pack]', form).forEach((x) => {
        const sel = x === p;
        x.classList.toggle('pack-on', sel); x.setAttribute('aria-checked', sel);
        const r = $('.radio', x); if (r) r.classList.toggle('radio-on', sel);
      });
      if (p.dataset.variantUrl && history.replaceState) history.replaceState(null, '', p.dataset.variantUrl);
      if (p.dataset.variantUrl) followSize(p);
      showVariantImage(p.dataset.variant);
      render();
    });
    on('click', '[data-qty-step]', (e, b) => {
      if (!pr.contains(b)) return;
      state.qty = Math.max(1, Math.min(20, state.qty + Number(b.dataset.qtyStep)));
      render();
    });
    const lineItems = () => {
      const p = current();
      return [{ id: Number(p.dataset.variant), quantity: state.qty * Number(p.dataset.units || 1) }];
    };
    on('click', '[data-atc]', (e, b) => {
      if (!pr.contains(b) && !(sticky && sticky.contains(b))) return;
      e.preventDefault();
      addItems(lineItems(), (current().dataset.label || 'Item') + ' added', b);
    });
    on('click', '[data-buy]', async (e, b) => {
      if (!pr.contains(b)) return;
      e.preventDefault();
      if (await addItems(lineItems(), '', b)) location.href = pr.dataset.checkout || '/checkout';
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); addItems(lineItems(), (current().dataset.label || 'Item') + ' added', $('[data-atc]', form)); });
    render();

    // sticky bar hides while the main add button is visible
    const mainAtc = $('[data-atc]', form);
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      sticky.removeAttribute('data-away');
      new IntersectionObserver(([en]) => { sticky.toggleAttribute('data-away', en.isIntersecting); }).observe(mainAtc);
    }
  });

  /* wishlist heart (saved on this device) */
  const wishKey = 'pp-wish';
  const wishes = () => { try { return JSON.parse(localStorage.getItem(wishKey) || '[]'); } catch (_) { return []; } };
  $$('[data-wish]').forEach((b) => b.setAttribute('aria-pressed', wishes().includes(b.dataset.wish)));
  on('click', '[data-wish]', (e, b) => {
    let w = wishes(); const h = b.dataset.wish; const had = w.includes(h);
    w = had ? w.filter((x) => x !== h) : w.concat(h);
    try { localStorage.setItem(wishKey, JSON.stringify(w)); } catch (_) { /* ignore */ }
    b.setAttribute('aria-pressed', !had);
    toast(had ? 'Removed from your saved list' : 'Saved on this device', false);
  });

  /* pincode estimate */
  on('submit', '[data-pin]', (e, f) => {
    e.preventDefault();
    const input = $('input', f), out = $('[data-pin-out]', f.parentElement), txt = $('[data-pin-text]', f.parentElement);
    const pin = (input.value || '').replace(/\D/g, '');
    input.value = pin;
    if (!/^[1-9]\d{5}$/.test(pin)) { out.hidden = false; out.classList.remove('c-good'); out.classList.add('c-sale'); txt.textContent = 'Please enter a valid 6-digit pincode'; return; }
    const eta = PP.eta || { metro: 3, other: 5, prefixes: [], cod: true };
    const metro = (eta.prefixes || []).some((p) => pin.indexOf(String(p).trim()) === 0);
    const d = new Date(); let add = metro ? eta.metro : eta.other;
    while (add > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) add--; }
    const when = d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    out.hidden = false; out.classList.add('c-good'); out.classList.remove('c-sale');
    txt.textContent = 'Estimated delivery by ' + when + (eta.cod ? ' · COD available' : '');
    try { localStorage.setItem('pp-pin', pin); } catch (_) { /* ignore */ }
  });
  $$('[data-pin] input').forEach((i) => { try { const v = localStorage.getItem('pp-pin'); if (v) i.value = v; } catch (_) { /* ignore */ } });

  /* reviews: "Read more" only on clamped texts, "Show all reviews" reveals the rest */
  const fitReviews = () => $$('[data-rv-body]').forEach((b) => {
    const btn = b.nextElementSibling;
    if (btn && btn.hasAttribute('data-rv-read') && !b.classList.contains('open')) btn.hidden = b.scrollHeight <= b.clientHeight + 2;
  });
  if ($('[data-rv-body]')) { fitReviews(); addEventListener('resize', fitReviews, { passive: true }); }
  on('click', '[data-rv-read]', (e, btn) => {
    const b = btn.previousElementSibling, open = b.classList.toggle('open');
    btn.textContent = open ? 'Show less' : 'Read more';
    btn.setAttribute('aria-expanded', open);
  });
  on('click', '[data-rv-all]', (e, btn) => {
    $$('[data-rv-extra]', btn.closest('section')).forEach((r) => { r.hidden = false; });
    btn.hidden = true;
    fitReviews();
  });

  /* review photos: full-size viewer with prev/next (arrows keys and swipe too) */
  const lb = $('[data-rv-lb]');
  if (lb) {
    const img = $('[data-rv-lb-img]', lb), n = $('[data-rv-lb-n]', lb);
    let list = [], at = 0;
    const show = (i) => {
      at = (i + list.length) % list.length;
      img.src = list[at];
      n.textContent = list.length > 1 ? (at + 1) + ' / ' + list.length : '';
      $$('[data-rv-lb-step]', lb).forEach((b) => { b.hidden = list.length < 2; });
    };
    on('click', '[data-rv-photo]', (e, a) => {
      e.preventDefault();
      const group = a.closest('[data-rv-group]');
      list = $$('[data-rv-photo]', group).map((x) => x.href);
      show(list.indexOf(a.href));
      if (lb.showModal) lb.showModal(); else lb.setAttribute('open', '');
    });
    const close = () => { if (lb.close) lb.close(); else lb.removeAttribute('open'); img.src = ''; };
    lb.addEventListener('click', (e) => {
      const step = e.target.closest('[data-rv-lb-step]');
      if (step) { show(at + Number(step.dataset.rvLbStep)); return; }
      if (e.target === lb || e.target.closest('.rv-lb-x') || e.target.hasAttribute('data-rv-lb-close')) close();
    });
    lb.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') show(at + 1); if (e.key === 'ArrowLeft') show(at - 1); });
    let x0 = null;
    lb.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', (e) => { if (x0 === null || list.length < 2) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1)); x0 = null; }, { passive: true });
    lb.addEventListener('close', () => { img.src = ''; });
  }

  /* frequently bought together */
  $$('[data-fbt]').forEach((box) => {
    const upd = () => {
      const on = $$('input[type=checkbox]', box).filter((c) => c.checked);
      const tot = on.reduce((a, c) => a + Number(c.dataset.price), 0);
      const mrp = on.reduce((a, c) => a + Number(c.dataset.mrp || c.dataset.price), 0);
      $$('[data-fbt-count]', box).forEach((el) => { el.textContent = on.length; });
      $('[data-fbt-total]', box).textContent = money(tot);
      const m = $('[data-fbt-mrp]', box); if (m) m.textContent = mrp > tot ? money(mrp) : '';
      $('[data-fbt-add]', box).disabled = on.length === 0;
    };
    box.addEventListener('change', upd);
    $('[data-fbt-add]', box).addEventListener('click', (e) => {
      const items = $$('input[type=checkbox]', box).filter((c) => c.checked).map((c) => ({ id: Number(c.dataset.variant), quantity: 1 }));
      addItems(items, items.length + (items.length === 1 ? ' item' : ' items') + ' added', e.currentTarget);
    });
    upd();
  });

  /* ---------------- collection: client-side filter + sort ---------------- */
  $$('[data-collection]').forEach((col) => {
    const grid = $('[data-grid]', col);
    if (!grid) return;
    const cards = $$('[data-card]', grid);
    const promo = $('[data-promo]', grid);
    const st = { pet: 'all', kind: 'all', concern1: 'all', concerns: [], prices: [], sort: 0 };
    const sorts = (col.dataset.sorts || 'Bestselling|Price: low to high|Newest').split('|');
    const ranges = { lt300: [0, 30000], mid: [30000, 40001], gt400: [40001, 1e12] };
    function apply() {
      let shown = cards.filter((c) => {
        const pets = (c.dataset.pets || '').split(' ').filter(Boolean);
        const con = (c.dataset.concerns || '').split(' ').filter(Boolean);
        const kind = c.dataset.kind;
        const price = Number(c.dataset.price);
        const okPet = st.pet === 'all' || pets.length === 0 || pets.includes(st.pet);
        const okKind = st.kind === 'all' || kind === st.kind || (st.kind === 'new' && Number(c.dataset.new) > (Date.now() / 1000 - 60 * 86400));
        const okCon = st.concerns.length === 0 || st.concerns.some((x) => con.includes(x));
        const okPrice = st.prices.length === 0 || st.prices.some((r) => price >= ranges[r][0] && price < ranges[r][1]);
        const okC1 = st.concern1 === 'all' || con.includes(st.concern1);
        return okPet && okKind && okCon && okPrice && okC1;
      });
      const ord = shown.slice();
      if (st.sort === 1) ord.sort((a, b) => a.dataset.price - b.dataset.price);
      else if (st.sort === 2) ord.sort((a, b) => b.dataset.new - a.dataset.new);
      else ord.sort((a, b) => a.dataset.index - b.dataset.index);
      cards.forEach((c) => c.setAttribute('data-out', ''));
      ord.forEach((c, i) => {
        c.removeAttribute('data-out');
        grid.appendChild(c);
        if (promo && i === 3) grid.appendChild(promo);
      });
      if (promo) promo.hidden = ord.length <= 4;
      const n = ord.length;
      $$('[data-count]', col).forEach((el) => { el.textContent = n + (n === 1 ? ' product' : ' products'); });
      $$('[data-count-n]', col).forEach((el) => { el.textContent = n; });
      $$('[data-count1]', col).forEach((el) => { el.textContent = n + ' of ' + el.dataset.total + ' ' + (el.dataset.noun || 'products'); });
      const empty = $('[data-empty]', col); if (empty) empty.hidden = n > 0;
      const badge = $('[data-filter-n]', col);
      if (badge) { const k = st.concerns.length + st.prices.length; badge.textContent = k; badge.hidden = k === 0; }
      $$('[data-sort-label]', col).forEach((el) => { el.textContent = sorts[st.sort]; });
    }
    on('click', '[data-f]', (e, b) => {
      if (!col.contains(b)) return;
      const k = b.dataset.f, v = b.dataset.v;
      if (k === 'concerns' || k === 'prices') {
        const arr = st[k]; const i = arr.indexOf(v);
        if (i >= 0) arr.splice(i, 1); else arr.push(v);
        if (b.type !== 'checkbox' && b.tagName !== 'INPUT') { b.classList.toggle('chip-on', i < 0); b.setAttribute('aria-pressed', i < 0); }
      } else {
        st[k] = v;
        $$('[data-f="' + k + '"]', col).forEach((x) => {
          const sel = x.dataset.v === v;
          x.setAttribute('aria-pressed', sel);
          if (x.classList.contains('subcat')) x.classList.toggle('subcat-on', sel);
          else if (x.classList.contains('chip')) x.classList.toggle('chip-on', sel);
          else x.classList.toggle('on', sel);
        });
      }
      apply();
    });
    on('click', '[data-sort]', (e, b) => { if (!col.contains(b)) return; st.sort = (st.sort + 1) % sorts.length; apply(); });
    on('click', '[data-clear]', (e, b) => {
      if (!col.contains(b)) return;
      st.pet = 'all'; st.kind = 'all'; st.concern1 = 'all'; st.concerns = []; st.prices = [];
      $$('[data-f]', col).forEach((x) => {
        const isAll = x.dataset.v === 'all';
        if (x.tagName === 'INPUT') x.checked = false;
        x.classList.toggle('chip-on', x.classList.contains('chip') && isAll && x.dataset.f !== 'concerns');
        x.classList.toggle('on', !x.classList.contains('chip') && !x.classList.contains('subcat') && isAll);
        x.classList.toggle('subcat-on', x.classList.contains('subcat') && isAll);
      });
      apply();
    });
    // start from URL (?pet=dog&concern=ticks) so menus can deep-link
    const q = new URLSearchParams(location.search);
    if (q.get('pet')) { const b = $('[data-f="pet"][data-v="' + q.get('pet') + '"]', col); if (b) b.click(); }
    if (q.get('concern')) { const b = $('[data-f="concerns"][data-v="' + q.get('concern') + '"], [data-f="concern1"][data-v="' + q.get('concern') + '"]', col); if (b) b.click(); }
    apply();
  });
  /* breed picker */
  $$('[data-breeds]').forEach((box) => {
    on('click', '[data-breed]', (e, b) => {
      if (!box.contains(b)) return;
      $$('[data-breed]', box).forEach((x) => { x.classList.toggle('chip-on', x === b); x.setAttribute('aria-pressed', x === b); });
      const d = b.dataset;
      $('[data-b="coat"]', box).textContent = d.coat;
      $('[data-b="rec"]', box).textContent = d.rec;
      const a = $('[data-b="url"]', box); if (a) a.href = d.url;
      const img = $('[data-b="box"] img', box); if (img && d.img) { img.src = d.img; img.srcset = ''; }
      const t = $('[data-b="box"]', box); if (t) t.style.setProperty('--tint', d.tint || '#FFFDF9');
    });
  });

  /* ---------------- cart page ----------------
     One change at a time: while the store is saving a change, the bag's buttons are locked, so the
     next tap always uses the freshly rendered line. Each change is a single request that also returns
     the re-rendered cart section (Section Rendering API) instead of a second fetch. */
  const cartRoot = $('[data-cart]');
  if (cartRoot) {
    const sectionId = cartRoot.dataset.section;
    let busy = false;
    function apply(res) {
      const html = res && res.sections && res.sections[sectionId];
      if (!html) return false;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart]');
      if (!fresh) return false;
      cartRoot.innerHTML = fresh.innerHTML;
      const n = Number(fresh.dataset.count);
      if (!Number.isNaN(n)) { setCount(n); cartRoot.dataset.count = n; }
      document.dispatchEvent(new CustomEvent('pp:cart'));
      return true;
    }
    async function send(url, body, btn, row) {
      if (busy) return null;
      busy = true;
      cartRoot.setAttribute('aria-busy', 'true');
      if (btn) btn.setAttribute('aria-busy', 'true');
      if (row) row.classList.add('line-busy');
      const opts = { sections: sectionId, sections_url: location.pathname };
      try {
        const res = await api(url, Object.assign(opts, body));
        if (!apply(res)) await refreshCart();
        return res;
      } catch (err) {
        toast(err.message, false);
        // put the bag back to what the store actually has
        const res = await api(root + 'cart/update.js', { sections: sectionId, sections_url: location.pathname }).catch(() => null);
        apply(res);
        return null;
      } finally {
        busy = false;
        cartRoot.removeAttribute('aria-busy');
        if (btn && btn.isConnected) btn.removeAttribute('aria-busy');
      }
    }
    on('click', '[data-line]', (e, b) => {
      if (!cartRoot.contains(b)) return;
      e.preventDefault();
      if (busy) return;
      const row = b.closest('[data-line-row]');
      const to = Math.max(0, Number(b.dataset.to));
      if (row) {
        if (to === 0) row.classList.add('line-out');
        else { const q = $('[data-qty-n]', row); if (q) q.textContent = to; }
      }
      send(root + 'cart/change.js', { id: b.dataset.line, quantity: to }, b, row);
    });
    on('click', '[data-cart-add]', (e, b) => {
      if (!cartRoot.contains(b)) return;
      e.preventDefault();
      send(root + 'cart/add.js', { items: [{ id: Number(b.dataset.cartAdd), quantity: 1 }] }, b);
    });
    on('submit', '[data-coupon]', async (e, f) => {
      e.preventDefault();
      const code = ($('input', f).value || '').trim();
      if (!code) return;
      const res = await send(root + 'cart/update.js', { discount: code }, $('button', f));
      const hit = res && (res.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      if (hit && !hit.applicable) toast(code.toUpperCase() + " isn't valid for this bag", false);
    });
    on('click', '[data-coupon-remove]', (e, b) => { e.preventDefault(); send(root + 'cart/update.js', { discount: '' }, b); });
    on('change', '[data-note]', (e, t) => { api(root + 'cart/update.js', { note: t.value }).catch(() => {}); });
  }

  /* reorder a past order */
  on('click', '[data-reorder]', (e, b) => {
    let items = [];
    try { items = JSON.parse(b.dataset.reorder).filter((x) => x && x.id); } catch (_) { /* ignore */ }
    if (!items.length) { toast('These items are no longer available', false); return; }
    addItems(items, 'Added to bag', b);
  });
  /* address forms: preselect saved country */
  $$('select[data-default]').forEach((s) => { const v = s.dataset.default; if (v) s.value = v; });

  /* address forms: State list follows the country, digits-only phone/pincode, clear required-field messages */
  $$('[data-address-form]').forEach((f) => {
    const country = $('[data-country-select]', f), prov = $('[data-province-select]', f);
    const fillStates = (keep) => {
      if (!country || !prov) return;
      const opt = country.options[country.selectedIndex];
      let list = [];
      try { list = JSON.parse((opt && opt.dataset.provinces) || '[]'); } catch (_) { list = []; }
      const want = keep || prov.dataset.default || prov.value;
      prov.innerHTML = '';
      if (!list.length) { prov.add(new Option('Not applicable', '')); prov.required = false; prov.disabled = true; return; }
      prov.disabled = false; prov.required = true;
      prov.add(new Option('Choose a state', ''));
      list.forEach(([value, label]) => prov.add(new Option(label, value)));
      if (want) { const hit = list.find(([v, l]) => v === want || l === want); if (hit) prov.value = hit[0]; }
    };
    fillStates();
    if (country) country.addEventListener('change', () => fillStates(''));
    $$('input[inputmode=numeric]', f).forEach((i) => i.addEventListener('input', () => {
      let v = i.value.replace(/\D/g, '');
      if (i.type === 'tel') {
        if (v.length === 12 && v.startsWith('91')) v = v.slice(2);
        else if (v.length === 11 && v.startsWith('0')) v = v.slice(1);
        v = v.slice(0, 12);
      }
      if (v !== i.value) i.value = v;
    }));
    $$('[data-msg]', f).forEach((i) => {
      i.addEventListener('invalid', () => { i.setCustomValidity(i.validity.valueMissing || i.validity.patternMismatch || i.validity.tooShort ? i.dataset.msg : ''); });
      i.addEventListener('input', () => i.setCustomValidity(''));
      i.addEventListener('change', () => i.setCustomValidity(''));
    });
  });

  /* refresh other pages' cart sections when the cart changes (e.g. back/forward cache) */
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart().catch(() => {}); });
})();
